import {IIndoorAirCaptureRangeLimit, IIndoorFloorCaptureLimit, ITrap, TrapType} from "@/types/trap";
import { v4 as uuidv4 } from 'uuid';


export enum OutdoorTrapAuditQuantity {
    high = 'HIGH',
    medium = 'MEDIUM',
    low = 'LOW',
    nil = 'NIL',
}

export enum IndoorFlyingTrapAuditQuantity {
    exceeding = 'EXCEEDING',
    medium = 'MEDIUM',
    inferior = 'INFERIOR',
}

export interface IAudit {
    uuid: string,
    inspection: number,
    area: string,
    label: string,
    trap: number,
    note: string,
    type: TrapType,
}

export interface IOutdoorTrapAudit extends IAudit {
    type: TrapType.outdoor,
    quantity: OutdoorTrapAuditQuantity,
    damaged: boolean,
}

export interface IIndoorFloorTrapAudit extends IAudit {
    type: TrapType.indoorFloor,
    capture_limit_crawling_lower: number,
    capture_limit_crawling_upper: number,
    capture_limit_rodents_lower: number,
    capture_limit_rodents_upper: number,
    crawling_amount: number,
    rodents_amount: number,
}

export interface IIndoorFlyingTrapAudit extends IAudit {
    type: TrapType.indoorFlying,
    capture_limit_lower: number
    capture_limit_upper: number
    capture_limit_acceptability_limits: string,
    quantity: IndoorFlyingTrapAuditQuantity,
}


export function generateAudit(trap: ITrap, area: string, label: string, inspection: number) {
    const now = Date.now();
    const audit: IAudit = {
        trap: trap.id,
        area: area,
        label: label,
        //id: -Math.round(now / 1000),
        uuid: uuidv4(),
        inspection: inspection,
        note: '',
        type: trap.type,
    }
    switch (trap.type) {
        case TrapType.outdoor:
            return {
                ...audit,
                quantity: OutdoorTrapAuditQuantity.nil,
                damaged: false,
            } as IOutdoorTrapAudit;
        case TrapType.indoorFloor:
            return {
                ...audit,
                crawling_amount: 0,
                rodents_amount: 0,
                capture_limit_crawling_lower: (trap.capture_limit as IIndoorFloorCaptureLimit)!.crawling_lower,
                capture_limit_crawling_upper: (trap.capture_limit as IIndoorFloorCaptureLimit)!.crawling_upper,
                capture_limit_rodents_lower: (trap.capture_limit as IIndoorFloorCaptureLimit)!.rodents_lower,
                capture_limit_rodents_upper: (trap.capture_limit as IIndoorFloorCaptureLimit)!.rodents_upper,
            } as IIndoorFloorTrapAudit
        case TrapType.indoorFlying:
            return {
                ...audit,
                capture_limit_lower: (trap.capture_limit as IIndoorAirCaptureRangeLimit)!.lower,
                capture_limit_upper: (trap.capture_limit as IIndoorAirCaptureRangeLimit)!.upper,
                capture_limit_acceptability_limits: (trap.capture_limit as IIndoorAirCaptureRangeLimit)!.acceptability_limits,
                quantity: IndoorFlyingTrapAuditQuantity.inferior,
            } as IIndoorFlyingTrapAudit
    }
}
